import { Dropdown } from "@lockerpm/design";
import { IFilterItemV2 } from "../Table/Filter/types";
import { DropdownItemRenderV2 } from "../antdHelpers/DropdownItemRender";
import { DropdownRenderV2 } from "../antdHelpers/DropdownRender";
import { ButtonV2 } from "../Button";
import { ChevronDown } from "@untitled-ui/icons-react";
import { ReactNode } from "react";
import { FormFieldWrapper } from "./helpers/FieldWrapper";

interface IFormSelectV2Props {
  id?: string;
  label: string;
  selected: IFilterItemV2;
  onChangeSelected: (newValue: IFilterItemV2) => void;
  options: IFilterItemV2[];
  requiredMark?: boolean;
  hint?: ReactNode;
  disabled?: boolean;
  placeholder?: string;
}

export const FormSelectV2 = ({
  id,
  label,
  selected,
  onChangeSelected,
  options,
  requiredMark = false,
  hint,
  disabled,
  placeholder,
}: IFormSelectV2Props) => {
  const syncWidthId = "dropdown-button-" + id;

  return (
    <FormFieldWrapper
      label={label}
      requiredMark={requiredMark}
      error={null}
      hint={hint}
    >
      <Dropdown
        menu={{
          items: options.map((item) => ({
            key: item.key,
            label: (
              <DropdownItemRenderV2
                label={
                  <>
                    {item.leftIcon ? item.leftIcon : null}
                    {item.getLabel()}
                  </>
                }
                isSelected={item.key === selected.key}
              />
            ),
          })),
          onClick: ({ key }) => {
            const selected = options.find((item) => item.key === key);
            if (selected) {
              onChangeSelected(selected);
            }
          },
        }}
        dropdownRender={(menu) => (
          <DropdownRenderV2 syncWidthId={syncWidthId}>{menu}</DropdownRenderV2>
        )}
        trigger={["click"]}
        disabled={disabled}
      >
        <ButtonV2 variant="secondary" color="gray" size="md" id={syncWidthId}>
          <div className="flex justify-between flex-1">
            {selected && selected.getLabel() ? selected.getLabel() : <span className="text-gray-v2-500 text-md font-regular">{placeholder}</span>}
            <ChevronDown className="h-5 w-5 min-w-5" />
          </div>
        </ButtonV2>
      </Dropdown>
    </FormFieldWrapper>
  );
};
